// console.log("script loaded");
$(document).ready(function (){

  if($("#check-member").length){
    let memberBaseUrl = "https://member-id.devbdd.com/"
    function otpInput() {
      var otpGroup = setInterval(() => {
        if ($(".otp-group").length) {
          $('.otp-group').find('input').each(function() {
            $(this).attr('maxlength', 1);
            $(this).on('keyup', function(e) {
              var parent = $($(".otp-group"));
    
              if (e.keyCode === 8 || e.keyCode === 37) {
                var prev = parent.find('input#' + $(this).data('previous'));
    
                if (prev.length) {
                  $(prev).select();
                }
              } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                var next = parent.find('input#' + $(this).data('next'));
    
                if (next.length) {
                  $(next).select();
                }
              }
            });
          });
    
          clearInterval(otpGroup)
        }
      }, 1000);
    }

    function sessionSet(key, value, expirationInMin = 1440) {
      let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin))
      let newValue = {
        phone: value,
        expirationDate: expirationDate.toISOString()
      }
      window.localStorage.setItem(key, JSON.stringify(newValue))
    }

    let dataToPost = {
      'shop': "sevenohseven.myshopify.com",
      'customer_id': "",
    }
    
    $(document).on("submit", "#check-member", function(e){
      e.preventDefault()
      $(".tada-signin .error-notif").remove()
      $(".response-lt").html("")
      $(this).find("button").html("Please wait...").attr("disabled", true)
      let phone_number = $(this).find("[name=phone_number]").val()
      
      dataToPost['phone'] = phone_number;

      setTimeout(() => {
        $.ajax({
          type: "POST",
          url: memberBaseUrl + "member/getMemberOnWebsite",
          data: dataToPost,
          success: function(response){
            let data = JSON.parse(response)
            $("#check-member").find("button").html("Continue").attr("disabled", false)
            
            if(data['status'] == 200){
              sessionSet('tada_session', dataToPost['phone'] ?? data['status']);
						  location.reload();
              // $.ajax({
              //   type: "POST",
              //   url: memberBaseUrl + "member/sendOtpOnly",
              //   data: dataToPost,
              //   success: function(response){
              //     let data = JSON.parse(response)

              //     if (data['status'] == 200) {
              //       $("#check-member").remove()
              //       $(".info-number").html("Enter your OTP").addClass("text-center")
              //       $(".otp-login").html(`
              //         <form action="${memberBaseUrl}member/verifyOtpOnly" method="post" id="verifyOtpOnly">
              //           <div class="form-group otp-group">
              //             <div class="otp-item">
              //               <input type="text" id="digit-1" name="digit-1" data-next="digit-2" />
              //             </div>
              //             <div class="otp-item">
              //               <input type="text" id="digit-2" name="digit-2" data-next="digit-3" data-previous="digit-1" />
              //             </div>
              //             <div class="otp-item">
              //               <input type="text" id="digit-3" name="digit-3" data-next="digit-4" data-previous="digit-2" />
              //             </div>
              //             <div class="otp-item">
              //               <input type="text" id="digit-4" name="digit-4" data-previous="digit-3" />
              //             </div>
              //           </div>
              //           <div class="form-group submit-btn-member">
              //             <button class="btn btn-dark w-100 text-uppercase">Verify OTP</button>
              //           </div>
              //         </form>
              //       `)

              //       otpInput()
              //     } else {
              //       // $(".response-lt").after(`${data['message']}`)
              //       var t = document.createElement("span");
              //       t.className = "Alert Alert--error atc-notif", t.innerHTML = data['message'];

              //       $("body").prepend(t)
              //       setTimeout(() => {
              //         t.className += " active";
              //       }, 200);
              //       setTimeout(function() {
              //         t.classList.remove("active");
              //         setTimeout(() => {
              //           t.remove()
              //         }, 500);
              //       }, 2700)
              //     }
              //   }
              // });
            }
            else{
              var t = document.createElement("span");
              t.className = "Alert Alert--error atc-notif", t.innerHTML = "You're not registered as member, please contact administrator.";

              $("body").prepend(t)
              setTimeout(() => {
                t.className += " active";
              }, 200);
              setTimeout(function() {
                t.classList.remove("active");
                setTimeout(() => {
                  t.remove()
                }, 500);
              }, 2700)
            }
          }
        });
      }, 1500);
    })

    $(document).on("submit", "#verifyOtpOnly", function(e) {
      e.preventDefault();
    
      var postUrl = $(this).attr("action") ?? `${memberBaseUrl}member/verifyOtpOnly`
      var otpValue = '';
      $('#verifyOtpOnly .otp-group input').each(function() {
        otpValue += $(this).val();
      });
      
      dataToPost['otp'] = otpValue;
    
      $.ajax({
        type: "POST",
        url: postUrl,
        data: dataToPost,
        beforeSend: function() {
          $("#verifyOtpOnly .submit-btn-member button").attr("disabled", true).html("Please wait...")
        },
        success: function(response) {
          let data = JSON.parse(response);
    
          if (data['status'] == 200 || data['status'] == 201) {
            sessionSet('tada_session', dataToPost['phone'] ?? data['status']);
						location.reload();
          }
          else {
            $("#verifyOtpOnly .submit-btn-member button").attr("disabled", false).html("Verify OTP")
            // $(".response-lt").html(`${data['message']}`)
            var t = document.createElement("span");
            t.className = "Alert Alert--error atc-notif", t.innerHTML = data['message'];

            $("body").prepend(t)
            setTimeout(() => {
              t.className += " active";
            }, 200);
            setTimeout(function() {
              t.classList.remove("active");
              setTimeout(() => {
                t.remove()
              }, 500);
            }, 2700)
          }
        }
      })
    })
  }

  if($('body').hasClass('template-page-booking') || $('body').hasClass('template-page-booking-dynamic')){
    $("body").html($(".booking-product")).show();
    let memberBaseUrl = "https://member-id.devbdd.com/"
    let data_session = JSON.parse(localStorage.getItem("tada_session"))

    if(data_session == null){
      location.href = `https://${Shopify.shop}`
    }
    
    let phone = data_session.phone;
    let campaign = $(".booking-product").attr("data-campaign")
    let dataToPost = {
      'shop': "sevenohseven.myshopify.com",
      'customer_id': "",
      'phone': phone
    }
    
    var handle = getParameterByName('product');
    if (handle) {
      $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        success: function(product) {
          let product_variant_name = "";

          if(product.variants.length){
            product_variant_name = ` - ` + product.variants[0].public_title;
          }
          
          checkMember(memberBaseUrl, dataToPost)
          dataToPost['campaign'] = campaign
          dataToPost['url_shopify'] = Shopify.shop
          
          $.ajax({
            type: "POST",
            url: memberBaseUrl + "booking/getEarlyBooking",
            data: dataToPost,
            success: function(response){
              let result = JSON.parse(response)
              if(result.status == 200){
                let data_booking = JSON.parse(result.data_booking)
                let product = JSON.parse(data_booking.product)

                let product_variant_name = "";
                if(product.variants.length){
                    product_variant_name = ` - ` + product.variants[0].public_title;
                }

                if(data_booking.size != null){
                  product_variant_name = product_variant_name.replace("All Size", data_booking.size)
                }
                
                $("#booking-form").html(`
                  <div class="booked-detail">
                    <h1 class="booking-title">Your booking order is confirmed</h1>
                    <p>No. Order: <b>${data_booking.order_name}</b></p>
                    <p>Name: <b>${data_booking.name}</b></p>
                    <p>Email: <b>${data_booking.email}</b></p>
                    <p>Phone: <b>0${data_booking.phone}</b></p>
                    <p>Product: <b>${product.name}${product_variant_name}</b></p>
                    <p class="info-detail">${result.info_detail}</p>
                  </div>
                `)

                if(result.phone_number != null && data_booking.opsi == 2){
                  setTimeout(() => {
                    var phoneNumber = result.phone_number;
                    var message = `Hi, please proceed my booking:\n\nNo. Order: ${data_booking.order_name}\nEmail: ${data_booking.email}\nProduct: ${product.name}${product_variant_name}\n\nThankyou.`;
                    var url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    
                    location.href = url
                  }, 1000);
                }
              }
            },
            error: function() {
              notif(2, "Error, please refresh page")
            }
          })
          
          $(".booking-product--name").html(product.title + product_variant_name)
          if(campaign == 'melissa-bimba-y'){
            let product_title_lowercase = product.title.toLowerCase();
            if(!product_title_lowercase.includes('sandal')){
              $(".form-size").remove()
            } 
          }

          setCookie('booking-product', JSON.stringify({
            id: product.id,
            name: product.title,
            image: product.featured_image,
            variants: product.variants
          }), 1);
        },
        error: function() {
          // jika produk tidak ditemukan / error, kembali ke halaman sebelumnya
          window.history.back();
        }
      });
    }
    else{
      window.history.back();
    }

    $(document).on("submit", "#booking-form", function(e){
      e.preventDefault();
      $("#booking-form .btn").html("Please wait...").attr("disabled", "disabled")

      data_session = JSON.parse(localStorage.getItem("tada_session"))
      phone = data_session.phone;
      dataToPost['phone'] = phone;

      let size = '';
      if(campaign == 'melissa-bimba-y'){
        if($(".form-size").length){
          size = $(".form-size [name=size]").val();
        }
      }

      $.ajax({
        type: "POST",
        url: memberBaseUrl + "member/getMemberOnWebsite",
        data: dataToPost,
        success: function(response){
          let data = JSON.parse(response)
          if(data['status'] == 200){
            let product = getCookie("booking-product")
            let data_booking = {
              url_shopify: Shopify.shop,
              name: $("#booking-form input#name").val(),
              email: $("#booking-form input#email").val(),
              phone: phone,
              guest: $("#booking-form select#guest").val(),
              product: product,
              campaign: campaign,
              size: size,
              opsi: $("#booking-form select#opsi").val()
            }

            $.ajax({
              type: "POST",
              url: memberBaseUrl + "booking/earlyBooking",
              data: data_booking,
              success: function(response){
                let result = JSON.parse(response)
                
                if(result.status == 200){
                  notif(1, result.message)
                  location.reload()
                }
                else{
                  $("#booking-form .btn").html("Booking").attr("disabled", false)
                  notif(2, result.message)
                }
              },
              error: function() {
                notif(2, "Error, please refresh page")
              }
            });
          }
          else{
            notif(2, "You're not regitered as member")
            location.href = `https://${Shopify.shop}`
          }
        }
      });
    })
  }

  if($(".template-page-event-registration").length){
    $(".template-page-event-registration").html($(".event-registration")).show();
    let memberBaseUrl = "https://member-id.devbdd.com/"
    let token = getParameterByName("token")
    if(token == null){
      location.href = `https://${Shopify.shop}`
    }

    token = token.replace(/\s+/g, '+');
    $.ajax({
      type: "POST",
      url: memberBaseUrl + "booking/decryptBooking",
      data: {token: token},
      beforeSend: function(){
        $("#registration-form").css("opacity", .3)
      },
      success: function(response){
        $("#registration-form").css("opacity", 1)
        $(".loader-event").hide();
        
        if(response != 400){
          let result = JSON.parse(response);
          let product = JSON.parse(result.product)

          let product_variant_name = "";
          if(product.variants.length){
              product_variant_name = ` - ` + product.variants[0].public_title;
          }
          
          let info_event = `Hi ${result.name}, thank you for your pre-book order!<br><br>We appreciate your pre-book order for ${product.name}${product_variant_name} & ${result.order_name}. You are entitled to an invitation for <b>two</b> to the Stanley Grand Launch at Grand Indonesia on 3rd August 2024.<br><br>We look forward to celebrating with you!`;
          
          if(result.regist){
            info_event = `Hi ${result.name}, Your registration for this event is confirmed. Please show this invitation at the registration table. See you there!`
            $("#registration-form .form-group, #registration-form .btn").remove()
            $(".event-registration-title").html("Registered")
          }

          $(".info-event").html(`${info_event}`)
        }
        else{
          notif(2, "Your token is not valid.")
          location.href = `https://${Shopify.shop}`
        }
      },
      error: function() {
        notif(2, "Error, please refresh page")
      }
    })

    $(document).on("submit", "#registration-form", function(e){
      e.preventDefault();
      $("#registration-form .btn").html("Please wait...").attr("disabled", "disabled")

      let data_registration = {
        token: token,
        guest: $(".guest-input select").val()
      }

      $.ajax({
        type: "POST",
        url: memberBaseUrl + "booking/eventRegistration",
        data: data_registration,
        success: function(response){
          let result = JSON.parse(response);
          notif(1, result.message)
          setTimeout(() => {
            location.reload()
          }, 2000);
        },
        error: function() {
          notif(2, "Error, please refresh page")
        }
      })
    })
    
    // $(document).on("change", "#presence", function(){
    //   let presence = $(this).val() * 1;
    //   $(".guest-input").show()
    //   if(presence == 2){
    //     $(".guest-input").hide()
    //   }
    // })
  }

  if($(".template-page-event-registration-dynamic").length){
    let data_session = JSON.parse(localStorage.getItem("tada_session"))

    if(data_session != null){
      $(".member-hero").remove()
      $(".event-registration").show();
      $(".template-page-event-registration-dynamic").html($(".event-registration")).show();
      let memberBaseUrl = "https://member-id.devbdd.com/"
      let url_shopify = Shopify.shop
      let phone = data_session.phone;
      let campaign = $(".event-registration").attr("data-campaign")
      let event_title = $(".event-registration").attr("data-title")

      $.ajax({
        type: "POST",
        url: memberBaseUrl + "booking/getEventRegistrationOnly",
        data: {phone, campaign, url_shopify},
        beforeSend: function(){
          $("#registration-only-form").css("opacity", .3)
        },
        success: function(response){
          $("#registration-only-form").css("opacity", 1)
          $(".loader-event").hide();
          
          let result = JSON.parse(response);
          if(result.status == 200){
            $(".event-registration--form-inner").remove()
            $(".event-registration-title").html("YOU ARE REGISTERED!")
            $(".info-event").html(result.message);
          }
        },
        error: function() {
          notif(2, "Error, please refresh page")
        }
      })
  
      $(document).on("submit", "#registration-only-form", function(e){
        e.preventDefault();
        $("#registration-only-form .btn").html("Please wait...").attr("disabled", "disabled")
        
        let name = $(this).find("input[name='name']").val()
        let email = $(this).find("input[name='email']").val()
        let address = $(this).find("textarea[name='address']").val()

        let data_registration = {
          phone, name, email, address, campaign, event_title, url_shopify
        }
  
        $.ajax({
          type: "POST",
          url: memberBaseUrl + "booking/eventRegistrationOnly",
          data: data_registration,
          success: function(response){
            let result = JSON.parse(response);
            if(result.status == 200){
              notif(1, result.message)
            }
            else{
              notif(2, result.message)
            }
            
            setTimeout(() => {
              location.reload()
            }, 2000);
          },
          error: function() {
            notif(2, "Error, please refresh page")
          }
        })
      })
    }
  }

  $('.brand-container').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    responsive:{
      0:{
        items:3
      },
      600:{
        items:5
      },
      1000:{
        items:5
      }
    }
  })

  $('.merchant-slide').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    navText:["<div class='nav-btn prev-slide merchant-slide-prev'></div>","<div class='nav-btn next-slide merchant-slide-next'></div>"],
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      1000:{
        items:1
      }
    }
  })

  $('.js-menu__open').click(function () {
    var menu = $(this).attr('data-menu');
    $(menu).toggleClass('js-menu__expanded');
    $(menu).parent().toggleClass('js-menu__expanded');
  });

  $('.js-menu__context, .js-menu__close').click(function (event) {
    if ($(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close')) {
      $('.js-menu__expanded').removeClass('js-menu__expanded');
    }
  });

  setTimeout(function () {
    $("#deskSizeChart").accordion({
      collapsible: true,
      heightStyle: "content",
      header: "h4",
      active: false,
    });
    $("#mobileSizeChart").accordion({
      collapsible: true,
      heightStyle: "content",
      header: "h4",
      active: false,
    });

    $("#deskSizeChart h4").addClass("header-accordionna");
    $("#mobileSizeChart h4").addClass("header-accordionna");
  }, 3000);
  $(".collection-wrapper").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 2,
      },
      640: {
        items: 2,
      },
      1140: {
        items: 4,
      },
    },
  });
  $(".slide-promo-bar").owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: false,
  });
  $(".featured-slide-collection").owlCarousel({
    items: 4,
    loop: true,
    nav: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2
      },
      640: {
        items: 2
      },
      1140: {
        items: 5
      }
    },
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: false,
  });

  var acc = document.getElementsByClassName("filter-button");
  var i;
  var url = window.location.pathname;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("filter-active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        if (url.includes('/collections/tada')) {
          panel.style.maxHeight = "100" + "%";
        } else {
          panel.style.maxHeight = "110" + "px";
        }
      }
    });
  }

  $(".filter-toggle").click(function () {
    var $this = $(this);
    var filter_close_toggle = $(".filter-toggle-close");
    if ($this.attr("aria-clicked") == "false") {
      $this.attr("aria-clicked", "true");
      filter_close_toggle.attr("aria-closed", "false");
      $('.collection-sidebar-panel').show()
      $('.scotch-panel-canvas').css('transform', 'unset')
    }
  });
  $(".filter-toggle-close").click(function () {
    var $this = $(this);
    var filter_toggle = $(".filter-toggle");
    if ($this.attr("aria-closed") == "false") {
      $this.attr("aria-closed", "true");
      filter_toggle.attr("aria-clicked", "false");
      $('.collection-sidebar-panel').hide()
      $('.scotch-panel-canvas').css('transform', 'translate3d(0px, 0px, 0px)')
    }
  });

  var min = $('input[name="filter.v.price.gte"]').val();
  if (min == '') {
    min = 0;
  }
  var max = $('input[name="filter.v.price.lte"]').val();
  if (max == '') {
    max = $('input[name="filter.v.price.gte"]').attr('max');
  }

  var fixed_max = $('input[name="filter.v.price.gte"]').attr('max');
  var parts = window.location.href.split('?')[0].split('/');
  var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
  if ($('.filter-item.cat').length > 0) {
    if ($('.filter-item.cat').children('.filter-cat').data('value') == lastSegment) {
      $('.filter-item.cat').children('.filter-cat').data('value', lastSegment).prop('checked', true).attr('disabled', true);
    }
  }

  $('.filter-item.cat').click(function () {
    var click_value = $(this).children('.filter-cat').data('value');
    var new_url = lastSegment.replace(lastSegment, click_value);
    if (!$(this).children('.filter-cat').is(':checked')) {
      window.location.href = new_url;
    }
  });

  $('.filter-cat').change(function () {
    if (this.checked) {
      var click_value = $(this).data('value');
      var new_url = lastSegment.replace(lastSegment, click_value);
      window.location.href = new_url;
    }
  });

  $('#flat-slider').slider({
    orientation: 'horizontal',
    range: true,
    animate: true,
    min: 0,
    max: Number(fixed_max),
    values: [Number(min), Number(max)],
    slide: function (event, ui) {
      if ((ui.values[1] - ui.values[0]) < 1) {
        return false;
      }

      $('input[name="filter.v.price.gte"]').val(ui.values[0])
      $('input[name="filter.v.price.lte"]').val(ui.values[1])
      window.location.href = window.location.href.split('?')[0] + '?filter.v.price.gte=' + ui.values[0] + '&filter.v.price.lte=' + ui.values[1]

    }
  });

  url = window.location.href;
  is_product = url.match(/.*\/products\/.*/);
  // console.log(url, is_product);
  if (window.location.href.includes('collections')) {
    if (is_product == null) {
      document.querySelector('#SortBy').addEventListener('change', function () {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set(this.name, this.value);
        window.location = `?${urlSearchParams}`;
      });
      // $('.size-digit-kebawah').appendTo('.2digit_kebawah');
      // $('.size-digit-keatas[data-sort-type=UK]').appendTo('.type-uk');
      // $('.size-digit-keatas[data-sort-type=US]').appendTo('.type-us');
      // $('.size-digit-keatas[data-sort-type=EUR]').appendTo('.type-eur');
      // function sortEm(a,b){
      //   return parseInt($(a).attr('data-sort-nomor')) > parseInt($(b).attr('data-sort-nomor')) ? 1 : -1;
      // }
      // $('.type-uk li').sort(sortEm).prependTo($('.type-uk'));
      // $('.type-us li').sort(sortEm).prependTo($('.type-us'));
      // $('.type-eur li').sort(sortEm).prependTo($('.type-eur'));
      var announce_height = $('#shopify-section-promo-bar').outerHeight();
      var header_height = $('.site-header-container').outerHeight();
      var headerc_height = $('.collection-header').outerHeight();
      // console.log(announce_height);
      // console.log(header_height);
      // console.log(headerc_height);
      var hasil_gabungan = announce_height + headerc_height;
      var window_height = $(window).height();
      var hasil_final = window_height - header_height;
      var hasil_mobile_lebih = header_height + headerc_height;
      var hasil_mobile_kurang = announce_height + header_height + headerc_height;
      $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
      $(window).scroll(function () {
        if ($(this).scrollTop() > hasil_gabungan) {
          $('.filter-sticky').addClass('is-sticky')
          $('.filter-sticky.is-sticky').css('max-height', 800 + 'px');
          $('.filter-sticky.is-sticky').css('top', 120 + 'px');
          $('.scotch-panel-wrapper').css('overflow', 'unset');
        } else {
          $('.filter-sticky').removeClass('is-sticky')
          $('.filter-sticky').css('max-height', 'inherit');
          $('.scotch-panel-wrapper').css('overflow', 'hidden');
        }
        if ($(this).scrollTop() > announce_height) {
          $('.filter-sticky .panel').css('top', hasil_mobile_lebih + 'px');
        } else {
          $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
        }
      })
    }
  }

  function getCartItems() {
    jQuery.getJSON('/cart.js', function (cart) {
      if (cart.item_count > 0) {
        // console.log(cart.items)
      } else {
        // console.log('There no items in the cart.');
      }
    });
  }

  setTimeout(() => {
    getCartItems();
  }, 400);


  if (is_product) {
    function number_formats(amount) {
      // Create our number formatter.
      var formatter = new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0
      });

      return formatter.format(amount); /* $2,500.00 */
    }

    function getCart() {
      jQuery.getJSON('/cart.js', function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        }));

        let cartData = cart.items;
        if (cart.item_count > 0) {
          refreshCart(cart, cartData)
          // console.log(cartData)
          jQuery('#cart-nav > div > .cart-header > p').remove();

          var buttonAtc = `
          	<div class="row expanded">
              <div class="small-12 columns">
                <a href="/checkout" id="checkout-button" class="button">Checkout</a>
              </div>
          	</div>
          `;
          if (jQuery('.cart-action-buttons #checkout-button').length < 1) {
            jQuery(buttonAtc).appendTo('.cart-action-buttons');
          }
        }
        else {
          jQuery('<p>You have no items in cart</p>').appendTo('#cart-nav > div > .cart-header');
          jQuery('#cart-nav > div > .cart-body > table').remove();
          jQuery('#cart-nav > div > .cart-body > table').remove();
          jQuery('.cart-action-buttons #checkout-button').remove();
        }

        jQuery('#checkout-button').click(function () {
          var hrefna = jQuery(this).attr('href')
          if (window.location.host == '127.0.0.1:9292') {
            alert(window.location.host + hrefna)
          } else {
            window.location.href = 'https://' + window.location.host + '/' + hrefna;
          }
        })
      });
    }

    function refreshCart(cart, cartData) {
      var tampungItem = '';

      $.each(cartData, function (index, value) {
        // console.log(value)
        var pricena = "" + value.final_line_price + "";
        var pricenaFormat = pricena.substring(0, pricena.length - 2);
        // console.log(pricenaFormat)
        // console.log(parseInt(pricenaFormat))

        tampungItem += `
            <tr>
              <td class="line-item-image cart-image">
                <img src="${value.image}">	
              </td>
              <td class="line-item-title">
                ${value.title}
                <div class="line-item-operations">
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">+</button>
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">-</button>
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">x</button>
                </div>
              </td>
              <td class="line-item-quantity">x${value.quantity}</td>
              <td class="line-item-price">Rp. ${number_format(parseInt(pricenaFormat))}</td>
            </tr>
        	`;
      })

      var totalPricena = "" + cart.items_subtotal_price + "";
      var totalPricenaFormat = totalPricena.substring(0, totalPricena.length - 2);
      var bodyCart = `
      <table>
        <tbody>
        ${tampungItem}
        </tbody>
        <tbody>
          <tr>
            <td colspan="2">Subtotal</td>
            <td></td>
            <td class="line-item-price">Rp. ${number_format(parseInt(totalPricenaFormat))}</td>
          </tr>
        </tbody>
      </table>
      <div id="append-sekarang"></div>
      `;

      if ($('#cart-nav').length > 0) {
        jQuery('#cart-nav > div > .cart-body').html(bodyCart);
      }
      else {
        jQuery(bodyCart).prependTo('#cart-nav > div > .cart-body');
      }

      // console.log($('.js-menu__context').length);

      jQuery('.change-item').click(function () {
        var idnaItem = jQuery(this).attr('data-variant-id');
        var qty = parseInt(jQuery(this).attr('data-quantity'));

        // console.log(idnaItem, qty)

        var url = '/cart/change.js';
        if (jQuery(this).text() == '+') {
          qty = 1;
          url = '/cart/add.js';
          // console.log(qty)
        }
        else if (jQuery(this).text() == '-') {
          qty = qty - 1;
        }
        else if (jQuery(this).text() == 'x') {
          qty = 0;
        }

        $.ajax({
          type: "POST",
          url: url,
          dataType: "json",
          data: {
            id: parseFloat(idnaItem),
            quantity: qty,
          },
        }).then((data) => {
          getCart();
        }).catch((error) => {
          // console.error('Error add to cart', error.responseJSON.description);
          alert(error.responseJSON.description);
        });
      })
    }

    $("#AddToCartForm").submit(function (x) {
      x.preventDefault();
      const idna = $('[name=id]').val();
      const qtyna = $('#productQuantity').val();

      // console.log(idna, qtyna)
      var items = [{ quantity: qtyna, id: idna }];

      $.ajax({
        type: "POST",
        url: '/cart/add.json',
        data: {
          items: items
        },
        success: function (data) {
          // console.log('success');
        },
        errors: function (err) {
          console.log(err);
        },
        dataType: 'application/json'
      });
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: qtyna,
          id: idna
        },
      }).then((data) => {
        // console.log('Success:', data);
        setTimeout(function () {
          if (jQuery('.js-menu__context.js-menu__expanded').length < 1) {
            jQuery('#cart-nav').toggleClass('js-menu__expanded')
            jQuery('#cart-nav').parent().toggleClass('js-menu__expanded')
          }
        }, 1000);
        setTimeout(() => {
          jQuery('.js-menu__close').trigger('click');
        }, 5000);
        setTimeout(function () {
          getCart();
        }, 400);
      }).catch((error) => {
        console.error('Error add to cart', error.responseJSON.description);
        alert(error.responseJSON.description);
      });
      // Now I will do a get to show the itens from cart

    })

  }

  jQuery('.change-item').click(function () {
    var idnaItem = jQuery(this).attr('data-variant-id');
    var qty = parseInt(jQuery(this).attr('data-quantity'));

    // console.log(idnaItem, qty)

    var url = '/cart/change.js';
    if (jQuery(this).text() == '+') {
      qty = 1;
      url = '/cart/add.js';
      // console.log(qty)
    }
    else if (jQuery(this).text() == '-') {
      qty = qty - 1;
    }
    else if (jQuery(this).text() == 'x') {
      qty = 0;
    }

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: {
        id: parseFloat(idnaItem),
        quantity: qty,
      },
    }).then((data) => {
      getCart();
    }).catch((error) => {
      // console.error('Error add to cart', error.responseJSON.description);
      alert(error.responseJSON.description);
    });
  })

  jQuery('#checkout-button').click(function () {
    var hrefna = jQuery(this).attr('href')
    if (window.location.host == '127.0.0.1:9292') {
      window.location.href = window.location.host + '/' + hrefna;
    } else {
      window.location.href = 'https://' + window.location.host + '/' + hrefna;
    }
  })

  var url = window.location.href;
  var segment = url.split("/").length - 1 - (url.indexOf("https://") == -1 ? 0 : 2);
  var segment_tags = url.split("+").length
  var segment_tags_test = url.split("+")
  // console.log(segment_tags_test);
  // console.log(segment_tags, segment);

  jQuery('#filter-resets').click(function () {
    var data_url = jQuery(this).attr('data-url');
    if (segment == 5) {
      location.href = data_url;
    } else if (segment_tags > 1) {
      location.href = data_url;
    } else if (segment_tags == 1 && segment == 4) {
      return false;
    }
  })
});
